import styled from 'styled-components'

import { Root, Field } from '@radix-ui/react-form'

export const FormFieldError = styled.div`
    color: red;
    font-size: small;
`

export const StyledForm = styled(Root)`
    .form-fields {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 0.5rem;
        margin-bottom: 1rem;
    }
`

export const FormRowContainer = styled(Field) <{ $labelWidth?: string }>`
    position: relative;

    &.form-slider {
        width: 100%;

        input {
            width: 5ch;
            text-align: center;
            text-indent: unset;
        }

        label {
            padding-bottom: 0;
        }
    }

    textarea,
    input {
        background-color: var(--color-surface);
        border-color: var(--gray-5);
    }

    &:not(.form-label-transition) {
        display: grid;
        grid-column: 1 / -1;
        grid-template-columns: subgrid;
        justify-items: start;
        align-items: center;
        grid-template-rows: auto auto 1fr;

        label {
            flex-basis: ${props => (props.$labelWidth ? props.$labelWidth : undefined)};
            flex-shrink: ${props => (props.$labelWidth ? 0 : undefined)};
        }
    }

    .form-popover-trigger {
        background-color: transparent;
        padding: 0;
        border: 0;
    }

    &.form-input,
    &.form-date-range-input,
    &.form-date-input {
        input,
        textarea {
            &:not([type='datetime-local']):not([type='date']) {
                width: 100%;
            }

            border: 1px solid var(--gray-5);
            border-radius: 0.2rem;
            color: var(--gray-11);
            padding: 0.55rem 0.5rem;
            outline: none;
            box-shadow: none;
            transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
            width: 100%;
        }

        input:focus {
            border: 1px solid var(--accent-8);
        }

        textarea {
            width: 100%;
            resize: vertical;
            min-height: 2.25rem;
        }
    }

    &.form-input:has(textarea) {
        label {
            align-self: flex-start;
            margin-top: 0.55rem;
        }
    }

    label {
        padding-right: 1rem;
    }

    .form-select {
        width: 100%;

        .react-select__control {
            background-color: var(--color-surface);
            border-color: var(--gray-5);
        }
        .react-select__indicators {
            & > * {
                color: var(--gray-11);
            }
            .react-select__indicator-separator {
                background-color: var(--gray-9);
            }
        }
        .react-select__single-value {
            color: var(--gray-11);
        }
        .react-select__placeholder {
            color: var(--gray-10);
        }

        .react-select__control--is-disabled {
            .react-select__indicators {
                display: none;
            }
        }
    }

    .form-file-input {
        display: inline-flex;
        flex-direction: row;
        align-items: center;

        input[type='file'] {
            display: none;
        }

        label {
            &:before {
                content: '' !important;
            }

            &:hover {
                color: var(--gray-12);
            }

            border: 1px solid var(--gray-5);
            display: inline-block !important;
            padding: 0.6rem 1.2rem;
            cursor: pointer;
            margin-right: 1rem;
            border-radius: 0.2rem;
            user-select: none;
            color: var(--gray-11);

            span {
                padding-right: 0 !important;
            }
        }

        svg {
            cursor: pointer;
        }

        label + span {
            margin-right: 0.5rem;
            color: var(--gray-11);
        }
    }

    &.form-date-range-input,
    &.form-date-input {
        input {
            text-align: center;
        }
    }

    &.form-label-transition {
        label {
            background-color: var(--color-background);
            border-radius: 0.5rem;
            padding-inline: 0.2rem;
            position: absolute;
            pointer-events: none;
            transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
            color: var(--gray-10);
            left: 1rem;
            top: 0.25rem;
        }

        &:focus-within label {
            transform: translate(-1rem, -1rem);
            font-size: 0.8rem;
            color: var(--accent-9);
        }

        label.filled {
            transform: translate(-1rem, -1rem);
            font-size: 0.8rem;
        }
    }

    .form-password-field {
        /* the eye icon is absolutely positioned inside the input */
        position: relative;
        display: flex;
        align-items: center;
        border-radius: 0.2rem;
        width: 100%;

        input {
            padding-right: 2rem;
        }

        button {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            padding: 0;
            border: 0;
            background: none;
            color: gray;
            cursor: pointer;

            &:hover:not(:disabled) {
                color: var(--gray-12);
            }

            &:focus-visible {
                outline: 2px solid var(--accent-8);
                border-radius: 0.2rem;
            }

            &:disabled {
                cursor: default;
            }
        }

        svg {
            padding-inline: 0.5rem;
            box-sizing: content-box;
        }
    }
`

export const SubmitButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    button {
        cursor: pointer;
    }
`

export const StyledImageBufferField = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    label {
        cursor: pointer;
        border: 1px solid var(--accent-8);
        border-radius: var(--radius-4);
        padding: 0.1rem 0.4rem !important;

        input {
            display: none;
        }
    }

    img {
        object-fit: contain;
    }

    > div {
        position: relative;
    }
`

export const RedText = styled.span`
    color: red;
`
